export const DEFAULT_PAGE_SIZE = 10;

export const poiGroupsPaginationParams = {
  page: 0,
  size: DEFAULT_PAGE_SIZE,
  // sort: 'id',
};
